import { Typography } from '@mui/material'
import {
  CategoryTitleAndDateContainer,
  ImageContainer,
  MostReadCardContainer,
  PositionContainer,
} from './styled'
import Image from 'next/image'
import { formatDate } from 'components/Blog/formatDate'
import Link from 'next/link'

const MostReadCard = ({ post, position }: { post: IPost; position: number }) => {
  return (
    <Link href={`/blog/${post.slug}`}>
      <MostReadCardContainer>
        <ImageContainer>
          <Image
            src={post?.thumbnail?.fullSize || '/assets/blog/fallback_image.svg'}
            alt={post.title}
            layout="fill"
            objectFit="cover"
            priority
            loader={({ src, width }) => `${src}?w=${width}`}
            blurDataURL={post?.thumbnail?.fullSize || '/assets/blog/fallback_image.svg'}
          />
          <PositionContainer>{position + 1}</PositionContainer>
        </ImageContainer>
        <CategoryTitleAndDateContainer>
          <Typography variant="overline" color="surface.400">
            {formatDate(post.created)}
          </Typography>
          <Typography variant="overline" color="primary.500">
            {post?.category?.title}
          </Typography>
          <Typography variant="subtitle2">{post.title}</Typography>
        </CategoryTitleAndDateContainer>
      </MostReadCardContainer>
    </Link>
  )
}

export default MostReadCard
